import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Api } from '../../../../shared/constants/api';
import { AiService } from '../ai.service';

export const AiGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const aiService: AiService = inject(AiService);
  const router: Router = inject(Router);
  const forbiddenPage: UrlTree = router.parseUrl(Api.forbidden);

  return aiService.aiEnabledForTenant$.pipe(
    map((aiEnabled: boolean): UrlTree | true => {
      return aiEnabled || forbiddenPage;
    }),
    catchError(() => of(forbiddenPage)),
  );
};
